"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_EDD_CONFIG = void 0;
const client_1 = require("@apollo/client");
exports.UPDATE_EDD_CONFIG = (0, client_1.gql) `
  mutation UpdateEDDConfig($input: UpdateEstimatedDeliveryDateConfigInput!) {
    updateEstimatedDeliveryDateConfig(input: $input) {
      estimatedDeliveryDateConfig {
        activations
        dateFormat
        orderFulfillmentConfig {
          maxDays
          minDays
          timeZone
          monday {
            ...scheduleFields
          }
          tuesday {
            ...scheduleFields
          }
          wednesday {
            ...scheduleFields
          }
          thursday {
            ...scheduleFields
          }
          friday {
            ...scheduleFields
          }
          saturday {
            ...scheduleFields
          }
          sunday {
            ...scheduleFields
          }
        }
        template
      }
    }
  }

  fragment scheduleFields on OrderFulfillmentSchedule {
    __typename
    cutoffTime
    dow
    enabled
    name
  }
`;
